import { render } from "./AppFooter.vue?vue&type=template&id=394d340c&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-394d340c"

export default script